import { createSelector } from 'reselect';

const selectdbnpartnersubscriptions = (state: any) => state.dbnpartnersubscriptions;


export const selectdbnpartnersubscriptionsCurrentItem = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.current);

export const selectdbnpartnersubscriptionsListItems = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectdbnpartnersubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectdbnpartnersubscriptionsQueryItems = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.query);

export const selectdbnpartnersubscriptionsCreatedItem = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.create);

export const selectdbnpartnersubscriptionsUpdatedItem = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.update);

export const selectdbnpartnersubscriptionsReadItem = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.read);

export const selectdbnpartnersubscriptionsDeletedItem = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.delete);

export const selectdbnpartnersubscriptionsSearchedItems = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.search);

export const selectdbnpartnersubscriptionsItemsCount = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.count);

export const selectdbnpartnersubscriptionsItemsFilter = createSelector([selectdbnpartnersubscriptions], (dbnpartnersubscriptions) => dbnpartnersubscriptions.filter);